import {CommentModel, CommentStatusesEnum, DraftCommentModel} from '../../models/api/commentModel';

export function computeCommentDraftHasDisplayableContent(comment: DraftCommentModel): boolean {
  return comment.text.trim().length > 0 || comment.attachments.length > 0 || Boolean(comment.annotation);
}

export function computeIsDraftComment(comment: CommentModel): comment is DraftCommentModel {
  return comment.status === CommentStatusesEnum.DRAFT;
}
